import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import MillingForm from "./millingsPage/MillingForm";
import MillingsList from "./millingsPage/MillingsList";
import useMillingsPageController from "./millingsPage/useMillingsPageController";

export default function MillingsPage() {
  const c = useMillingsPageController();
  const [search, setSearch] = useState("");
  const [deleting, setDeleting] = useState(null);
  const query = search.trim().toLocaleLowerCase();
  const rows = c.millings.filter((m) => [m.name, m.materialType, ...(m.variants || []).map((v) => v.name)].some((v) => String(v || "").toLocaleLowerCase().includes(query)));
  return <div className="container">
    <h1>{c.t("millings")}</h1>
    <p><Link to="/milling-splitter">DXF- és képdaraboló megnyitása</Link></p>
    <div className="d-flex gap-3 mb-3"><input type="search" aria-label="Marás keresése" className="form-control" placeholder="Marás vagy változat keresése…" value={search} onChange={(e) => setSearch(e.target.value)} />
      <button className="btn btn-primary text-nowrap" onClick={() => c.open()}>+ Marások hozzáadása</button></div>
    {!c.drafts && !deleting && c.error && <p role="alert" className="text-danger">{c.error}</p>}
    <MillingsList millings={rows} loading={c.loading} onEdit={c.open} />
    <MillingForm drafts={deleting ? null : c.drafts} setDrafts={c.setDrafts} busy={c.busy} error={c.error} onSave={c.save}
      onDelete={setDeleting} onToggleActive={c.toggleActive} />
    <Modal show={!!deleting} backdrop="static" onHide={() => { if (!c.busy) setDeleting(null); }}>
      <Modal.Header closeButton={!c.busy}><Modal.Title>Marás törlése</Modal.Title></Modal.Header>
      <Modal.Body>
        <p>Törlöd a(z) „{deleting?.name}” marást és az összes változatát?</p>
        <p>A hozzájuk tartozó képek és DXF-ek is törlődnek, ha más marás nem használja őket. A törlés nem vonható vissza.</p>
        {c.error && <p role="alert" className="text-danger">{c.error}</p>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" disabled={c.busy} onClick={() => setDeleting(null)}>Mégse</Button>
        <Button variant="danger" disabled={c.busy} onClick={async () => { if (await c.remove(deleting)) setDeleting(null); }}>
          {c.busy ? "Törlés…" : "Végleges törlés"}
        </Button>
      </Modal.Footer>
    </Modal>
  </div>;
}
